module.exports = __webpack_public_path__ + "static/CI-Journeys2-aab86ae6213ff1cdb456e9801af1fd92.jpg";